import * as types from '../constants/ActionTypes';

export function connectToChatAs(name) {
    return {
        type: types.CONNECT_TO_CHAT,
        userName: name
    };
}

/*export function sendMessage(text) {
    return {
        type: types.SEND_MESSAGE,
        text
    };
}*/

export function RecieveMessages(messages) {
    return {
        type: types.RECIEVE_MESSAGES,
        messages
    };
}

export function updateChannels(channels) {
    return {
        type: types.UPDATE_CHANNELS,
        channels
    };
}

export function updateUsers(users) {
    return {
        type: types.UPDATE_USERS,
        users
    };
}

export function change_channel(id) {
    return {
        type: types.CHANGE_CHANNEL,
        id
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/chatActions.js
 **/